import { render, staticRenderFns } from "./AdminDeviceList.vue?vue&type=template&id=35ff7c83&scoped=true&"
import script from "./AdminDeviceList.vue?vue&type=script&lang=js&"
export * from "./AdminDeviceList.vue?vue&type=script&lang=js&"
import style0 from "./AdminDeviceList.vue?vue&type=style&index=0&id=35ff7c83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff7c83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ff7c83')) {
      api.createRecord('35ff7c83', component.options)
    } else {
      api.reload('35ff7c83', component.options)
    }
    module.hot.accept("./AdminDeviceList.vue?vue&type=template&id=35ff7c83&scoped=true&", function () {
      api.rerender('35ff7c83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminDeviceList.vue"
export default component.exports